import { render, staticRenderFns } from "./createWeeklyShift.vue?vue&type=template&id=035598e2&"
import script from "./createWeeklyShift.vue?vue&type=script&lang=js&"
export * from "./createWeeklyShift.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports